import React, { useState, useEffect, useRef } from 'react';
import listService from '../services/list.service';
import ListOfLists from 'components/Own/List/ListOfLists';
import AdminNavbar from 'components/Navbars/AdminNavbar';
import NoData from 'components/Own/ui/NoData';
import SearchComponent from 'components/Own/Search/SearchComponent';

function Feed() {
  const [searchTerm, setSearchTerm] = useState("");
  const [lists, setLists] = useState([]);
  const [hasLists, setHasLists] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const observer = useRef();

  useEffect(() => {
    if (searchTerm !== "") {
      setLists([]);
      if (pageNumber !== 1) {
        setPageNumber(1);
      } else {
        searchLists(searchTerm, pageNumber, 10);
      }
    }
  }, [searchTerm]);

  useEffect(() => {
    searchLists(searchTerm, pageNumber, 10);
  }, [pageNumber]);

  const searchLists = (searchTerm, page, limit) => {
    listService.searchLists(searchTerm, page, limit)
      .then(response => {
        if (response.data.lists.length > 0) {
          setHasLists(true);
          setLists(prevLists => [...prevLists, ...response.data.lists]);
        }
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  const loadMore = () => {
    setPageNumber(prevPageNumber => prevPageNumber + 1);
  }

  const lastListElementRef = useRef();

  useEffect(() => {
    if (isLoading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    });

    if (lastListElementRef.current) {
      observer.current.observe(lastListElementRef.current);
    }

    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, [isLoading]);

  return (
    <div className='bg-gray-50 min-h-screen'>
      <AdminNavbar lightBackground={true} />
      <SearchComponent setSearchTerm={setSearchTerm} />
      {isLoading ? (
        <NoData text={'Sorry! It seems like we are having a problem. We are working on it... Come back soon!'}></NoData>
      ) : hasLists ? (
        <>
          <div className='pt-32'>
            <ListOfLists userLists={lists} />
            <div ref={lastListElementRef}></div>
          </div>
        </>
      ) : (
        <NoData text={'Sorry! It seems like we are having a problem. We are working on it... Come back soon!'}></NoData>
      )}
    </div>
  );
}

export default Feed;